// this is an autogenerated file from DesignSystem/DataVaxiomPatientInsuranceForm/Employers/EmployerItem/Employer/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomPatientInsuranceForm_Employers_EmployerItem_Employer(
  $organization_id: numeric!
  $search_term: String!
  $selected_employer: numeric
  $search_selected_employer: Boolean!
) {
  employers: vaxiom_employers(
    where: {
      organization_id: { _eq: $organization_id }
      name: { _ilike: $search_term }
    }
    order_by: { name: asc }
    limit: 250
  ) {
    id
    text: name
  }

  selected_employer: vaxiom_employers(
    where: { id: { _eq: $selected_employer } }
  ) @include(if: $search_selected_employer) {
    id
    text: name
  }
}

`